import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import {
  AVISO_EMPENDENCIA_DURACAO_MS,
  MENSAGEM_AVISO_EMPENDENCIA,
  consumirAvisoEmpendenciaPendente,
} from "../utils/empendencia";

function AvisoEmpendenciaSnackbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (consumirAvisoEmpendenciaPendente()) {
      setOpen(true);
    }
  }, []);

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={AVISO_EMPENDENCIA_DURACAO_MS}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        sx={{ width: "100%" }}
        elevation={6}
        variant="filled"
      >
        {MENSAGEM_AVISO_EMPENDENCIA}
      </Alert>
    </Snackbar>
  );
}

export default AvisoEmpendenciaSnackbar;
